import { Injectable } from '@angular/core';

import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class SuppService {
  private apiUrl = '/supps';
  private apiSpringUrl = '/spring/supps';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    return this.http.get(url);
  }

  complete(selectItems: object[], updprogramCd: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/complete`;
    const jsonUnit: object[] = [];
    for (let i = 0; i < selectItems.length; i++) {
      jsonUnit.push({
        suppId: selectItems[i]['suppId']
      });
    }
    const jsonInput: object = { selectItems: jsonUnit, updprogramCd: updprogramCd };
    return this.http.post(url, jsonInput);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/supp/supp.service.ts